export function kliknalWideo() {
    document.addEventListener('click', function (event) {
        const target = event.target.closest('[data-ga-event-kliknal-wideo]');
        if (!target) return;

        window.dataLayer = window.dataLayer || [];

        const videoURL = target.getAttribute('href') || '';
        const productCode = document.querySelector('#hero-title')?.textContent || '';
        const currentUrl = window.location.origin
            + window.location.pathname
            + window.location.search;
        const videoTitle = target.getAttribute(
            'data-video-title'
        ) || '';

        window.dataLayer.push({
            event: 'kliknal_wideo',
            video_url: videoURL,
            video_title: videoTitle,
            product_code: productCode,
            product_url: currentUrl,
        });
    });
}
